module.exports = App.MapChildMixin = Ember.Mixin.create
  containerLayer: Ember.computed(->
    @nearestOfType App.MapContainerMixin
  )
  didInsertElement: ->
    @_super.apply this, arguments
    @registerWithParent()
    return
  willDestroyElement: ->
    @_super.apply this, arguments
    @unregisterWithParent()
    return
  registerWithParent: ->
    container = @get('containerLayer')
    #assert(`Tried to use ${this} outside the context of a container layer.`, container);
    container.registerChild this
    return
  unregisterWithParent: ->
    container = @get('containerLayer')
    if container
      container.unregisterChild this
    return